var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFrame15(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3958 1.83334H10.1671C6.5772 1.83334 3.66699 5.93739 3.66699 11C3.66699 16.0626 6.5772 20.1667 10.1671 20.1667H12.3958",
    fill: "#FFA413"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.8619 20.1667C15.4359 20.1667 18.3332 16.0626 18.3332 11C18.3332 5.93738 15.4359 1.83331 11.8619 1.83331C8.28793 1.83331 5.39062 5.93738 5.39062 11C5.39062 16.0626 8.28793 20.1667 11.8619 20.1667Z",
    fill: "#FEA101"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M11.8619 20.1667C15.4359 20.1667 18.3332 16.0626 18.3332 11C18.3332 5.93738 15.4359 1.83331 11.8619 1.83331C8.28793 1.83331 5.39062 5.93738 5.39062 11C5.39062 16.0626 8.28793 20.1667 11.8619 20.1667Z",
    fill: "#FFC35C"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M12.3941 18.0725C15.1369 18.0725 17.3605 14.8577 17.3605 10.8919C17.3605 6.92624 15.1369 3.7114 12.3941 3.7114C9.65129 3.7114 7.42773 6.92624 7.42773 10.8919C7.42773 14.8577 9.65129 18.0725 12.3941 18.0725Z",
    fill: "#FEA101"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M13.0043 7.48611C14.1536 7.48611 15.0852 9.05933 15.0852 11C15.0852 12.9072 14.1854 14.4595 13.0635 14.5125L13.0043 14.5139L12.997 14.5136L12.9451 14.5125C12.9141 14.511 12.8834 14.5085 12.8528 14.5047L9.06543 14.2629L12.6123 13.8105L11.7396 13.7906C11.484 13.4599 11.2752 13.0313 11.1328 12.5381L9.73428 12.3804L11.0549 12.232C10.9699 11.8487 10.9234 11.4335 10.9234 11C10.9234 10.5665 10.9699 10.1513 11.0549 9.76791L9.73428 9.6195L11.1328 9.46202C11.2753 8.96859 11.4841 8.53989 11.7398 8.2091L12.6123 8.18919L9.06543 7.7371L12.8445 7.49631C12.8972 7.48954 12.9506 7.48611 13.0043 7.48611ZM13.0043 9.68229C12.5734 9.68229 12.224 10.2723 12.224 11C12.224 11.7277 12.5734 12.3177 13.0043 12.3177C13.4353 12.3177 13.7847 11.7277 13.7847 11C13.7847 10.2723 13.4353 9.68229 13.0043 9.68229Z",
    fill: "currentColor"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame15);
export default __webpack_public_path__ + "static/media/Frame (15).69162806f84e97c2146f6201669b55a6.svg";
export { ForwardRef as ReactComponent };